module.exports = __webpack_public_path__ + "static/media/AI_LOGO_SPARTACUS.5483a6c2.png";